import React from 'react'

const state = {
    hashid: null,
    gallery: {
        ready: false,
        allow_share: false,
        single_download: false,
        download_all: false
    },
    data: null,
    isMobile: false
}

const GalleryContext = React.createContext(state)

export default GalleryContext
